import { get, post, put, destroy } from "./base";

const ExportServ = {
    // New Generic Export
    exportData: (payload) => post("/export", payload, { responseType: 'blob' }),

    // Template Management
    getTemplates: () => get("/export/templates"),
    createTemplate: (payload) => post("/export/templates", payload),
    updateTemplate: (id, payload) => put(`/export/templates/${id}`, payload),
    deleteTemplate: (id) => destroy(`/export/templates/${id}`),
};

export default ExportServ;
